import { useAdFree } from "lib/hooks/use-ad-free";
import { gql, useQuery } from "@apollo/client";
import SearchBar from "components/SearchBar";
import { ThetaContainer } from "components/Theta/ThetaContainer";
import { MediaQuery } from "@outplayed/responsive";
import { RampInContentContainer } from "@ugg/shared/components/Ads/RampInContent";
import { ExclusiveFeatureCarousel } from "@ugitgud/legos/components/plus/ExclusiveFeatureCarousel";
import { GameLibraryContainer } from "@ugitgud/legos/components/home-page/GameLibraryContainer";
import wpClient from "lib/wp-client";
import { rewriteWPImageUrlToS3, getArticleUrl } from "lib/helperFunctions";
import { formatDate } from "lib/formatDate";
import { TagBasedAdUnits } from "@outplayed/ramp";

const GET_LATEST_POSTS = gql`
  query GetLatestLolPostsMobile($first: Int!) {
    posts(first: $first, where: { categoryName: "lol" }) {
      nodes {
        id
        slug
        date
        title
        featuredImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
  }
`;

const GET_MAIN_SITE_OPTIONS = gql`
  query getMainSiteOptionsMobile {
    mainSiteOptions {
      mainSiteOptions {
        mainSiteColoredLabel
        mainSiteRemixIconClass
        mainSiteStickyExcerpt
        mainSiteStickyLabelIconBorderColor
        mainSiteStickyUrl
      }
    }
  }
`;

const LandingPageContainer = (props) => {
  const { className } = props;
  const isAdFree = useAdFree();

  const { data, loading, error } = useQuery(GET_LATEST_POSTS, {
    client: wpClient,
    variables: { first: 3 },
  });

  const { data: optionsData } = useQuery(GET_MAIN_SITE_OPTIONS, {
    client: wpClient,
  });

  const opts = optionsData?.mainSiteOptions?.mainSiteOptions;
  const sticky = {
    label: opts?.mainSiteColoredLabel,
    url: opts?.mainSiteStickyUrl,
    excerpt: opts?.mainSiteStickyExcerpt,
    icon: opts?.mainSiteRemixIconClass,
    color: opts?.mainSiteStickyLabelIconBorderColor,
  };

  const posts = data?.posts?.nodes || [];

  return (
    <div className={`landing-page-container_mobile ${className || ""}`}>
      <div className="all-landing-page-content content-side-padding">
        <div className="landing-background-year-in-review">
          <div className="overlay" />
          <div className="background-image" />
        </div>

        {/* Header */}
        <div className="landing-header">
          <img className="ugg-logo" src="https://static.bigbrain.gg/assets/ugg/logo/ugg-logo.svg" alt="U.GG" />
        </div>

        {/* Search bar */}
        <div className="large-search flex gap-x-3">
          <SearchBar placeholder="Search a Champion" searchBarId="mobile-search-landing" autoFocus={false} />
          <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE" renderNullOnFail isClient>
            <ThetaContainer />
          </MediaQuery>
        </div>

        {/* Ad 1 — mobile leaderboard */}
        {!isAdFree && (
          <div className="mt-4">
            <RampInContentContainer
              className="mb-[20px]"
              id="ugg-home-top"
              unitId="pw-home-top"
              type={TagBasedAdUnits.LeaderboardATF}
              showAdLabel
              showPlusLink
              ignoreSkinAd
              slotClassName="flex items-center justify-center w-full h-[50px] overflow-hidden"
            />
          </div>
        )}

        {/* Exclusive feature section */}
        <div className="mt-8 [&_section]:!mb-0">
          <ExclusiveFeatureCarousel />
        </div>

        {/* Patch notes / sticky banner */}
        {sticky.label && sticky.url && (
          <a
            href={sticky.url}
            className="flex items-center justify-between gap-2 mt-4 mb-8 px-[14px] py-[10px] rounded-[3px] border border-purple-500 bg-purple-400 no-underline"
          >
            <div className="flex items-center gap-2 min-w-0">
              {sticky.icon && <i className={sticky.icon} style={{ color: sticky.color }} />}
              <span className="text-[12px] font-bold whitespace-nowrap" style={{ color: sticky.color }}>
                {sticky.label}
              </span>
              <span className="text-[12px] text-lavender-50 truncate">{sticky.excerpt}</span>
            </div>
            <span className="text-[12px] text-accent-blue-400 font-semibold whitespace-nowrap">View Patch Notes</span>
          </a>
        )}

        {/* Latest News */}
        <div className="mb-8">
          <h2 className="text-white font-inter text-[20px] font-bold mb-4">Latest News</h2>
          {!loading && !error && posts.length > 0 && (
            <div className="news-post-area !mt-0 !mb-0">
              <div className="flex flex-col">
                {posts.map((post) => (
                  <div key={post.slug} className="news-item large !mb-3 last:!mb-0">
                    <div
                      className="zoomable-image"
                      style={{
                        backgroundImage: `url(${rewriteWPImageUrlToS3(post.featuredImage?.node?.mediaItemUrl || "")})`,
                      }}
                    />
                    <div className="inner-content">
                      <h3>{post.title.length > 60 ? `${post.title.substring(0, 60)}...` : post.title}</h3>
                      <p className="post-date">{formatDate(post.date)}</p>
                    </div>
                    <a href={getArticleUrl(post.slug)} className="link-whole" />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Ad 2 */}
        {!isAdFree && (
          <div className="mb-8">
            <RampInContentContainer
              id="ugg-home-in-content"
              unitId="pw-home-mid"
              type={TagBasedAdUnits.MediumRectATF}
              showAdLabel
              showPlusLink
              slotClassName="flex items-center justify-center w-full h-[250px] overflow-hidden"
            />
          </div>
        )}

        {/* Games library */}
        <GameLibraryContainer utmSource="ugghome" utmCampaignGameCode="lol" />
      </div>
    </div>
  );
};

export default LandingPageContainer;
